


























import { Vue, Component, Prop } from "vue-property-decorator";
import { currentScoutingStore } from "@/store/typed";
import ScoutingArea from "@/models/ScoutingArea";

@Component
export default class ScoutingAreaItem extends Vue {
  @Prop({ required: true }) readonly scoutingArea!: ScoutingArea;
  @Prop({ default: false }) readonly deletable!: boolean;
  @Prop({ default: true }) readonly navigate!: boolean;

  private item = Object.assign(new ScoutingArea(), this.scoutingArea);

  hovered = false;

  onDelete() {
    currentScoutingStore.destroyScoutingArea(this.scoutingArea.id);
  }

  get scouting() {
    return currentScoutingStore.scouting;
  }

  get isItemSelected() {
    return (
      currentScoutingStore.analysisCurrentScoutingArea?.id ===
      this.scoutingArea.id
    );
  }

  onSelectClicked() {
    if (this.navigate) {
      currentScoutingStore.updateScoutingArea(this.item);
      currentScoutingStore.centerOnArea(this.item);

      this.$router.push({
        name: "scouting-area-show",
        params: { id: this.item.id },
      });
    } else {
      this.$emit("clicked", this.scoutingArea);
    }
  }
}
